import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Multisitefilter: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m390 660c-4.97 0-9.62-2.46-12.41-6.58-112.77-166.16-167.59-279.5-167.59-346.49 0-103.07 80.75-186.93 180-186.93 11.02 0 22.07 1.04 32.82 3.1l-5.64 29.46c-8.9-1.7-18.04-2.57-27.18-2.57-82.71 0-150 70.4-150 156.93 0 29.21 13.37 71.4 39.73 125.42 24.96 51.14 62.02 113.58 110.27 185.8 48.25-72.22 85.31-134.66 110.27-185.8 26.36-54.02 39.73-96.21 39.73-125.42 17.01 0 29.82 15.53 26.51 32.22-13.69 68.89-67.74 172.3-164.1 314.28-2.79 4.11-7.44 6.58-12.41 6.58z' />
    <path d='m390.11 390c-49.57 0-89.89-40.33-89.89-89.89s40.33-89.89 89.89-89.89 89.89 40.33 89.89 89.89-40.33 89.89-89.89 89.89zm0-149.79c-33.03 0-59.89 26.87-59.89 59.89s26.87 59.89 59.89 59.89 59.89-26.87 59.89-59.89-26.87-59.89-59.89-59.89z' />
    <path d='m670 180h-210v-30h180c16.57 0 30 13.43 30 30z' />
    <circle cx='540' cy='165' r='45' />
    <path d='m750 270h-210v-30h180c16.57 0 30 13.43 30 30z' />
    <circle cx='645' cy='255' r='45' />
  </IconBase>
));

Multisitefilter.displayName = 'Multisitefilter';

export default Multisitefilter;
